import { ls } from './config.js';
import { isDefined } from './utilities.js';
import { dataObject } from './data-object.js';

const userSingleCourseQuizzesTableHeadings = [
	{
		data: 'quizName',
		title: sprintf(reportingApiSetup.localizedStrings.tablesColumnsQuizName, reportingApiSetup.learnDashLabels.quiz)
	},
	{ data: 'score', title: ls('Score') },
	{ data: 'detailedReport', title: ls('Detailed report') },
	{ data: 'dateCompleted', title: ls('Date completed') },
	{ data: 'certificateLink', title: ls('Certificate Link') }
];

const userSingleCourseQuizzesTableData = function(courseID) {
	var tableData = [];

	return tableData;
};

export {
	userSingleCourseQuizzesTableHeadings,
	userSingleCourseQuizzesTableData
};
